import businessClient from 'src/services/clients/business'
import { IMeta, IResource } from 'src/common/interfaces/index.js'

const IResourceListResponse = { meta: IMeta, data: { list: [IResource] } }

export const resource = {
  /**
   * @param {type: string, language: string} filter
   * @return {Promise<IResourceListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('resources/data', { filter }, { signal })
  },
}
